import { Search } from "@mui/icons-material";
import { InputAdornment, ListSubheader } from "@mui/material";
import React from "react";
import { MuiTextField } from "../../textField/MuiTextfield";
import { SelectGroupedTextboxWrapper } from "../MuiGroupedSelect.style";

interface Props {
  filterText: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClick: (e: React.MouseEvent<HTMLInputElement>) => void;
  placeholder: string;
  requiredARIALabel: string;
}

const GroupedSelectSearchInput: React.FC<Props> = ({
  filterText,
  onChange,
  onKeyDown,
  onClick,
  placeholder,
  requiredARIALabel,
}) => (
  <ListSubheader
    disableSticky
    role="presentation"
    tabIndex={-1}
    sx={{ padding: 0, margin: 0 }}
  >
    <SelectGroupedTextboxWrapper>
      <MuiTextField
        placeholder={placeholder}
        className="mui-text-field select-search-input"
        value={filterText}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onClick={onClick}
        showCloseIcon
        id="select-box-search"
        startAdornment={
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        }
        requiredARIALabel={requiredARIALabel}
      />
    </SelectGroupedTextboxWrapper>
  </ListSubheader>
);

export default GroupedSelectSearchInput;
